import styled from '@emotion/styled';
import PerspectiveColoredDialog from '../../PerspectiveColoredDialog';

const AttachedTasksDialog = styled(PerspectiveColoredDialog)(({ theme }) => ({
  '.MuiDialog-paper': {
    maxWidth: 800,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.shaded,
    display: 'block',
  },
}));

export default AttachedTasksDialog;
